import ru from "./ru";
import en from "./en";

const messages = {
    ru,
    en
};

export default messages;